import { makeAutoObservable, runInAction } from "mobx";

import { aiChatsService } from "../api/aiChatsService";
import {
  AiChatsSortType,
  IAiChat,
  IGetAllChatsParams,
  IGetMyChatsParams,
  IMyAiChat,
} from "./types";

export enum AiChatsTab {
  ALL,
  RECENT,
}

export class AiChatsStore {
  allChats: IAiChat[] = [];
  myChats: IMyAiChat[] = [];
  sortType: AiChatsSortType = AiChatsSortType.POPULAR;

  activeTab: AiChatsTab = AiChatsTab.ALL;

  constructor() {
    makeAutoObservable(this);
  }

  setSortType(sortType: AiChatsSortType) {
    this.sortType = sortType;
  }

  setActiveTab(tab: AiChatsTab) {
    this.activeTab = tab;
  }

  async getAllChats(params: IGetAllChatsParams) {
    const response = await aiChatsService.getAllChats(params);

    runInAction(() => {
      this.allChats = response.data;
    });

    return response;
  }

  async getMyChats(params: IGetMyChatsParams) {
    const response = await aiChatsService.getMyChats(params);

    runInAction(() => {
      this.myChats = response.data;
    });

    return response;
  }
}
